import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  DataGrid,
  Table,
} from '../../components/index';
import {
  getObject,
  vinculo,
} from '../../utils/listsSelect';
import { trataMensagensErro, doGet } from '../../utils/requests';
import { habilitarUploadNaConsultaDoRequerimento } from '../../utils/helpers';
import { tamanhoMaximoArquivoUpload } from '../../utils/constants';
import ModalUploadArquivos from '../../pages/requerimentos/ModalUploadArquivos';

class UploadArquivos extends Component {
  constructor() {
    super();
    const initialState = this.getInitialState();
    this.state = initialState;
  }

  getInitialState = () => ({
    acaoModal: 'criacao',
    showModal: false,
    errosDependenteSelecionado: null,
    exigenciasDependentes: null,
    dependenteSelecionado: null,
    showDocumentUploadModal: false,
    requerimentoModalDocumento: {},
    possuiExigenciaDocumento: false,
    apagouArquivo: false,
    botaoNovoUploadDesabilitado: false,
  })

  showDocumentUploadModal = () => {
    if (this.props.requerimento.estado === 2) {
      this.showDocumentUploadModalExigencias();
    } else {
      this.setState({ showDocumentUploadModal: !this.state.showDocumentUploadModal });
    }
  }

  verificarHabilitacaoBotao = () => {
    if ((this.props.requerimento.estado === 2 && this.props.listaExigencias.length === 0)) {
      this.setState({ botaoNovoUploadDesabilitado: true });
    } else if (this.props.requerimento.estado === 2 && this.props.listaExigencias.length > 0) {
      this.setState({ botaoNovoUploadDesabilitado: false });
    }
  }

  createCustomInsertButton = () => (
    <Button
      disabled={this.state.botaoNovoUploadDesabilitado}
      onClick={() => this.showDocumentUploadModal()}
      hint="Carregar Arquivo"
      icon="ico-upload"
    />
  );

  addVinculoLabel = (vinculoSelecionado) => {
    const obj = getObject(vinculo, vinculoSelecionado);
    return obj.label;
  }

  /**
   * Identifica dependentes a ter parecer emitido:
   *  - capacidades: INVALIDO_INCAPAZ, INVALIDO_CAPAZ
   */
  alterarDependenteMedico = (dependenteSelecionado) => {
    if (this.props.acao === 'emitir-parecer-medico') {
      if (dependenteSelecionado.capacidade === 3 || dependenteSelecionado.capacidade === 5) {
        return true;
      }
      return false;
    }
    return false;
  }

  validacaoExigenciaDependente = (exigenciasDependenteSelecionado) => {
    const exigenciasNovas = this.state.exigenciasDependentes.filter(item =>
      (exigenciasDependenteSelecionado.includes(item) ? null : item));
    this.setState({ exigenciasDependentes: exigenciasNovas });
  }

  /**
   * Determina a acao que estara disponivel para cada dependente:
   * - Usuario esta criando um requerimento ou cumprindo exigencias, dependente pode ser alterado;
   * - Usuario esta emitindo parecer, dependente pode ser alterado se tiver a Capacidade adequada;
   * - Em outras situacoes, o dependente pode apenas ser visualizado.
   */
  createActionColumn = indice => (
    <React.Fragment>
      {(this.props.estadoFormulario !== 'criado' && ['novo', 'indeferidos', 'cumprir-exigencia'].includes(this.props.acao)) ||
      habilitarUploadNaConsultaDoRequerimento(this.props.requerimento, this.props.acao, null) ? (
        <Button
          className="dtp-inverse"
          hint="Excluir arquivo"
          icon="ico-doc-minus"
          mini
          onClick={() => this.deleteArquivo(indice)}
        />
      ) : ''}
    </React.Fragment>
  );

  addSituacaoLabel = (tipoDocumento) => {
    const obj = getObject(this.props.tiposDocumentos, tipoDocumento);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
    // const obj = getObject(situacao, situacaoSelecionado);
    // return obj.label;
  }
  /**
   * Determina quais colunas devem ser exibidas na tabela de arquivos
   */
  montaArquivosTableHeader = () => {
    const tableHeader = [
      {
        id: 'tipoDocumento',
        label: 'Tipo de Documento',
        dataFormat: this.addSituacaoLabel,
      },
      {
        id: 'nome',
        label: 'Arquivo',
      },
    ];
    if (this.props.tipoRequerimento === 2) {
      tableHeader.push({
        id: 'nomeDependente',
        label: 'Dependente',
      });
    }
    tableHeader.push({
      id: 'acoes',
      label: 'Ação',
      dataFormat: this.createActionColumn,
    });
    return tableHeader;
  }

  options = {
    hideSizePerPage: true,
    insertBtn: this.createCustomInsertButton,
    noDataText: 'Nenhum arquivo foi adicionado à lista',
    sizePerPage: 5,
  };

  /**
   * Altera um dependente da lista
   */
  editArquivo = (indice, arquivoSelecionado) => {
    this.setState({
      cell: indice,
      arquivoSelecionado,
    });
  }

  /**
   * Exclui um arquivo da lista
   */
  deleteArquivo = (row) => {
    const { arquivos } = { ...this.props };
    if (this.props.requerimento.estado === 2) {
      // "recuperar o objeto row e joga-lo devolta para a lista de exigencias"
      // pesquisar na lista de exigencias do requerimento onde
      // o tipoDocumento que esta sendo excluido é igual ao
      // tipoDocumento da exigencia e jog-la devolta na colecao de exigencias
      this.setState({ apagouArquivo: true });
      if (this.props.requerimento.dependentes) {
        const indexExigencia = this.props.requerimento.exigencias
          .findIndex(exi => (exi.tipoDocumento === arquivos[row].tipoDocumento &&
          exi.codigoDependente === arquivos[row].codigoDependente));

        this.props.listaExigencias.push(this.props.requerimento.exigencias[indexExigencia]);
      } else { // aposentadoria
        const indexExigencia =
        this.props.requerimento.exigencias
          .findIndex(exi => (exi.tipoDocumento === arquivos[row].tipoDocumento));
        this.props.listaExigencias.push(this.props.requerimento.exigencias[indexExigencia]);
      }
    }
    arquivos.splice(row, 1);
    this.alteraListaArquivos(arquivos);
    // this.verificarHabilitacaoBotao();
  }

  alteraListaArquivos = (listaArquivos) => {
    this.props.handleChange({ value: listaArquivos, isValid: listaArquivos.length > 0 });
  }

  handleModal = (modal) => {
    this.setState({ [modal]: !this.state[modal] });
  }
  /**
   * Adiciona arquivo a lista
   */
  addArquivo = (arquivo) => {
    if (arquivo) {
      const { arquivos } = { ...this.props };
      const tamanhoDocumentoUpload = arquivo.documento.size;
      if ((tamanhoDocumentoUpload > tamanhoMaximoArquivoUpload)) {
        trataMensagensErro([`Certifique-se de que o documento ${arquivo.documento.name} possui tamanho inferior a 3 mb.`]);
      } else {
        arquivos.push(arquivo);
      }
      this.alteraListaArquivos(arquivos, null);
      this.setState(this.handleModal('showDocumentUploadModal') /* () => this.verificarHabilitacaoBotao(), */);
    }
  }

  showDocumentUploadModalExigencias = () => {
    this.setState({
      requerimentoModalDocumento: this.props.requerimento,
    });

    let tipo = 'pensao';
    if (this.props.tipoRequerimento === 1) {
      tipo = 'aposentadoria';
    }
    doGet(
      `requerimentos-compensacao-${tipo}/${this.props.requerimento.protocolo}`,
      this.handleResponseUploadDocumento,
      this.handleErrorEncerramentoExigencia,
    );
  }

  handleResponseUploadDocumento = (response) => {
    if (response.data.exigencias && response.data.exigencias.length > 0) {
      const paramPossuiExigenciaDocumento = response.data.exigencias
        .filter(exigencia => exigencia.tipoDocumento).length > 0;
      this.setState(
        {
          requerimentoModalDocumento: response.data,
          possuiExigenciaDocumento: paramPossuiExigenciaDocumento,
        },
        () => this.handleModal('showDocumentUploadModal'),
      );
    }
  }

  handleErrorEncerramentoExigencia = () => {}

  render() {
    const listaArquivosIndexada = this.props.arquivos !== undefined ? this.props.arquivos.map((item, i) => {
      const itemIndexado = item;
      itemIndexado.acoes = i;
      itemIndexado.nome = itemIndexado.documento.name;
      return itemIndexado;
    }) : '';
    return (
      <DataGrid title="Upload de Arquivos" icon="ico-doc-list" >
        <Table
          bordered
          data={listaArquivosIndexada}
          insertRow={(this.props.estadoFormulario !== 'criado' &&
            ['novo', 'cumprir-exigencia', 'indeferidos'].includes(this.props.acao)) ||
            habilitarUploadNaConsultaDoRequerimento(this.props.requerimento, this.props.acao, this.props.temBloqueioAtivoContratoDtp)
          }
          options={this.options}
          listaTableHeader={this.montaArquivosTableHeader()}
          pagination
          fetchInfo={this.fetchInfo}
        />
        { this.state.showDocumentUploadModal ? (
          <ModalUploadArquivos
            {...this.props}
            requerimento={this.props.requerimento}
            handleDocumentSent={this.handleDocumentSent}
            handleFailDocumentSent={this.realizaConsulta}
            handleModal={() => this.handleModal('showDocumentUploadModal')}
            showModal={this.state.showDocumentUploadModal}
            tiposDocumentos={this.props.tiposDocumentos}
            addArquivo={this.addArquivo}
            possuiExigenciaDocumento={this.state.possuiExigenciaDocumento}
            listaExigencias={this.props.listaExigencias}
          />
        ) : ''}
      </DataGrid>
    );
  }
}

UploadArquivos.propTypes = {
  acao: PropTypes.string.isRequired,
  arquivos: PropTypes.arrayOf({
    tipo: PropTypes.number,
    nome: PropTypes.string,
  }).isRequired,
  tiposDocumentos: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  estadoFormulario: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
  tipoRequerimento: PropTypes.string.isRequired,
};

UploadArquivos.defaultProps = {
  tiposDocumentos: [],
};

export default UploadArquivos;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/UploadArquivos.jsx